// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ftcl_status-label {
  flex-wrap: nowrap;
}
.ftcl_status-label > div {
  /* Reduce the space between the icon and the label, caused by the table rules */
  --pf-v6-l-flex--spacer--column: 0.5rem;
}

.fctl-status-display-content__popover .pf-v6-c-popover__body {
  overflow-y: auto;
  max-height: 30vh;
}
`, "",{"version":3,"sources":["webpack://./../../libs/ui-components/src/components/Status/StatusDisplay.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;AACnB;AACA;EACE,+EAA+E;EAC/E,sCAAsC;AACxC;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB","sourcesContent":[".ftcl_status-label {\n  flex-wrap: nowrap;\n}\n.ftcl_status-label > div {\n  /* Reduce the space between the icon and the label, caused by the table rules */\n  --pf-v6-l-flex--spacer--column: 0.5rem;\n}\n\n.fctl-status-display-content__popover .pf-v6-c-popover__body {\n  overflow-y: auto;\n  max-height: 30vh;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
